import { render, staticRenderFns } from "./RequisitionManagers.vue?vue&type=template&id=1da16328&scoped=true&"
import script from "./RequisitionManagers.vue?vue&type=script&lang=js&"
export * from "./RequisitionManagers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da16328",
  null
  
)

export default component.exports